import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    contactModalIsVisible: false,
    error: {
      isActive: false,
      data: null,
      entityConfig: null,
      previousUrl: null,
    },
  },
  reducers: {
    toggleContactModal(state) {
      state.contactModalIsVisible = !state.contactModalIsVisible;
    },
    setError(state, action) {
      state.error.isActive = true;
      state.error.data = action.payload.error;
      state.error.entityConfig = action.payload.entityConfig;
      state.error.previousUrl = action.payload.previousUrl;
    },
    clearError(state) {
      state.error.isActive = false;
      state.error.data = null;
      state.error.entityConfig = null;
      state.error.previousUrl = null;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
